import {useState} from "react";
import styled from "styled-components";
import {Switch} from "ui/base/switch/Switch";
import {themeFontSize} from "ui/theme";

const NotificationSection = () => {
    const [notifications, setNotifications] = useState({
        receiveMessage: true,
        newClassRequest: true,
        clientCancelClass: true,
        rescheduleClassRequest: true,
        supportRequests: true,
        newItemsOffers: true,
    });

    return (
        <Container>
            <Section>
                <Title>Instructor Notifications</Title>
                <ToggleRow>
                    <Label>Receiving a message</Label>

                    <Switch
                        id="recieved_msg"
                        toggled={notifications.receiveMessage}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                receiveMessage: !prev.receiveMessage,
                            }))
                        }
                    />
                </ToggleRow>

                <ToggleRow>
                    <Label>New class request</Label>

                    <Switch
                        id="new_class_request"
                        toggled={notifications.newClassRequest}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                newClassRequest: !prev.newClassRequest,
                            }))
                        }
                    />
                </ToggleRow>

                <ToggleRow>
                    <Label>User cancels an upcoming class</Label>

                    <Switch
                        id="client_cancel_class"
                        toggled={notifications.clientCancelClass}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                clientCancelClass: !prev.clientCancelClass,
                            }))
                        }
                    />
                </ToggleRow>

                <ToggleRow>
                    <Label>New re-schedule request</Label>

                    <Switch
                        id="reschedule_class_request"
                        toggled={notifications.rescheduleClassRequest}
                        onChange={() =>
                            setNotifications((prev) => ({
                                ...prev,
                                rescheduleClassRequest: !prev.rescheduleClassRequest,
                            }))
                        }
                    />
                </ToggleRow>
            </Section>

            {/*<Section>*/}
            {/*  <Title>{"Teache Notification"}</Title>*/}
            {/*  <ToggleRow>*/}
            {/*    <Label>Support Requests</Label>*/}

            {/*    <Switch*/}
            {/*      id={"support_requests"}*/}
            {/*      toggled={notifications.supportRequests}*/}
            {/*      onChange={() =>*/}
            {/*        setNotifications((prev) => ({*/}
            {/*          ...prev,*/}
            {/*          supportRequests: !prev.supportRequests,*/}
            {/*        }))*/}
            {/*      }*/}
            {/*    />*/}
            {/*  </ToggleRow>*/}

            {/*  <ToggleRow>*/}
            {/*    <Label>New items and offers </Label>*/}

            {/*    <Switch*/}
            {/*      id={"new_items_offers"}*/}
            {/*      toggled={notifications.newItemsOffers}*/}
            {/*      onChange={() =>*/}
            {/*        setNotifications((prev) => ({*/}
            {/*          ...prev,*/}
            {/*          newItemsOffers: !prev.newItemsOffers,*/}
            {/*        }))*/}
            {/*      }*/}
            {/*    />*/}
            {/*  </ToggleRow>*/}
            {/*</Section>*/}
        </Container>
    );
};

const Container = styled.div`
    padding: 1rem;
    width: 100%;
    display: grid;
    max-width: 900px;
    margin-inline: auto;
    gap: 1rem;
    font-family: var(--font-secondary);
`;

const Section = styled.div`
    margin-bottom: 1rem;
`;

const ToggleRow = styled.div`
    display: flex;
    justify-items: center;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    padding: 1em;
    border-radius: 6px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 1px solid #edf0ff;
`;

const Title = styled.h3`
    font-size: ${themeFontSize("big")};
    font-weight: 600;
    margin-bottom: 1rem;
`;

const Label = styled.label`
    font-weight: 500;
`;

export {NotificationSection};
